import { api } from '@moxiltd/moxijs/src/api/api.js';

export class Favorites {
    private favorites = [];
    private favoriteList;

    constructor() {
        this.favoriteList = document.getElementById('favorites-list');

        const storedFavorites = localStorage.getItem('favorites');
        if (storedFavorites) {
            this.favorites = JSON.parse(localStorage.getItem('favorites'));
        }

        if (!this.favoriteList) {
            this.handleList();
            this.updateCounter();
        } else {
            this.loadFavorites();
        }
    }

    private handleList() {
        document.querySelectorAll('.add-favorite').forEach(button => {
            const offerId = button.dataset.offerId;

            if (this.favorites.indexOf(offerId) !== -1) {
                button.classList.add('is-active');
            }

            button.addEventListener('click', (e) => {
                e.preventDefault();
                const index = this.favorites.indexOf(offerId);
                if (index === -1) {
                    this.favorites.push(offerId);
                    button.classList.add('is-active');
                } else {
                    this.favorites.splice(index, 1);
                    button.classList.remove('is-active');

                    if (this.favoriteList) {
                        const listEntry = button.closest('.listing_entry');
                        listEntry.classList.add('fade-out');
                    }
                }

                localStorage.setItem('favorites', JSON.stringify(this.favorites));
                this.updateCounter();

                if (index !== -1 && this.favoriteList) {
                    this.loadFavorites();
                }
            });
        });

        document.querySelectorAll('.listing_entry').forEach(entry => {
            entry.addEventListener('click', (e) => {
                if (e.target.classList.contains('add-favorite') || e.target.parentElement.classList.contains('add-favorite'))
                    e.preventDefault();
            });
        });
    }

    private updateCounter() {
        const count = this.favorites.length;
        document.querySelectorAll('.favorite-counter').forEach(counter => {
            counter.querySelector('span').innerHTML = count.toString()
            if (count === 0) {
                counter.classList.add('is-hidden');
            } else {
                counter.classList.remove('is-hidden');
            }
        });
    }

    private loadFavorites() {
        api.api_post(window.favoriteLoadUrl, {ids: this.favorites}).then(result => {
            this.setInnerHTML(result.data);
            ParkApp.init();
            this.handleList();
            this.updateCounter();
        });
    }

    //taken from https://stackoverflow.com/questions/2592092/executing-script-elements-inserted-with-innerhtml
    // this.favoriteList.innerHTML = result.data; -> does not execute scripts... this function does somehow^^
    private setInnerHTML(html) {
        this.favoriteList.innerHTML = html;

        Array.from(this.favoriteList.querySelectorAll("script")).forEach( oldScriptEl => {
            const newScriptEl = document.createElement("script");

            Array.from(oldScriptEl.attributes).forEach( attr => {
                newScriptEl.setAttribute(attr.name, attr.value)
            });

            const scriptText = document.createTextNode(oldScriptEl.innerHTML);
            newScriptEl.appendChild(scriptText);

            oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
        });
    }
}
